<template>
  <div
    v-if="hasSaveBtn || hasClearBtn"
    class="gw_filter_body_btns"
    style="gap: 0.25rem"
  >
    <div
      v-if="hasSaveBtn"
      class="gw_btn text-medium weight_500"
      style="--height: 1.75rem"
      data-tst="filterbtns_save"
      @click="$emit('click:save')"
    >
      {{ $t('btn.save') }}
    </div>
    <div
      v-if="hasClearBtn"
      class="gw_btn text-medium weight_500"
      style="--clr-back: var(--clr-error); --height: 1.75rem"
      data-tst="filterbtns_clear"
      @click="$emit('click:clear')"
    >
      {{ $t('btn.clear') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'GwFilterBtns',
  props: {
    hasSaveBtn: { default: true },
    hasClearBtn: { default: true },
  },
  emits: ['click:save', 'click:clear'],
}
</script>
<style lang="scss" scoped>
.gw_filter_body_btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
